export enum AssociatedEnum {
    Queries = 0,
    Insight = 1
}
